import { AsyncPipe } from '@angular/common';
import { Component, inject, signal } from '@angular/core';
import { IonApp, IonRouterOutlet } from '@ionic/angular';
import { Actions, ofType } from '@ngrx/effects';
import { filter, map } from 'rxjs';

import { BiometricOfferComponent, LoadingComponent, ToastComponent } from '@ninety/mobile/platform/components';
import { NetworkService } from '@ninety/mobile/platform/services';
import { NotificationActions } from '@ninety/mobile/platform/state';

@Component({
  selector: 'nty-app',
  imports: [AsyncPipe, IonApp, IonRouterOutlet, ToastComponent, BiometricOfferComponent, LoadingComponent],
  template: `
    <ion-app>
      <ion-router-outlet (activate)="hasRouteActivated.set(true)" />
      @if (!hasRouteActivated()) {
        <div class="launch">
          <nty-loading />
        </div>
      }
      <nty-toast [options]="$any(vm.toastMessage$ | async)" />
      <!-- The app shell, not a route: the offer has to see the machine reach the authorized state, and
           the navigation that follows is handled after the state advanced. -->
      <nty-biometric-offer />
    </ion-app>
  `,
  styles: `
    .launch {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      z-index: 99;
      background: var(--ion-background-color, #fff);
    }
  `,
})
export class AppComponent {
  /**
   * Whether the router has ever activated a route.
   *
   * Not "is the machine restoring": that is also true on every app-resume refresh, and a veil keyed
   * on it would cover a working app. This is the narrower fact — the outlet is empty, so there is no
   * screen — and it can only be true once per launch.
   */
  readonly hasRouteActivated = signal(false);

  actions$ = inject(Actions);

  network = inject(NetworkService);

  vm = {
    toastMessage$: this.actions$.pipe(
      ofType(NotificationActions.showToast),
      filter(action => action?.options !== null),
      map(action => action.options)
    ),
  };

  constructor() {
    this.initializeApp();
  }

  private initializeApp() {
    this.initializeNetworkListener();
  }

  private initializeNetworkListener() {
    this.network.initializeNetworkListener();
  }
}
